export default "__VITE_ASSET__CNo1tF6___"